import * as React from "react";
import type { SVGProps } from "react";
const SvgLightning02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m13.28 2.4-9.6 11.52H12l-.64 7.68 8.96-11.52H12l1.28-7.04"
    />
  </svg>
);
export default SvgLightning02;
